import axios from "axios";
import { base_url } from "../../../utils/baseUrl";
import { config } from "../../../utils/axiosconfig";

const getContentBlocks = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString 
    ? `${base_url}cms/content-blocks?${queryString}`
    : `${base_url}cms/content-blocks`;
  const response = await axios.get(url);
  return response.data;
};

const getContentBlock = async (id) => {
  const response = await axios.get(
    `${base_url}cms/content-blocks/${id}`,
    config
  );
  return response.data;
};

const getContentBlockBySlug = async (slug) => {
  const response = await axios.get(
    `${base_url}cms/content-blocks/slug/${slug}`
  );
  return response.data;
};

const createContentBlock = async (blockData) => {
  const response = await axios.post(
    `${base_url}cms/content-blocks`,
    blockData,
    config
  );
  return response.data;
};

const updateContentBlock = async (id, blockData) => {
  const response = await axios.put(
    `${base_url}cms/content-blocks/${id}`,
    blockData,
    config
  );
  return response.data;
};

const uploadContentBlockImages = async (id, formData) => {
  const uploadConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  };
  const response = await axios.put(
    `${base_url}cms/content-blocks/upload/${id}`,
    formData,
    uploadConfig
  );
  return response.data;
};

const deleteContentBlock = async (id) => {
  const response = await axios.delete(
    `${base_url}cms/content-blocks/${id}`,
    config
  );
  return response.data;
};

const cmsContentBlocksService = {
  getContentBlocks,
  getContentBlock,
  getContentBlockBySlug,
  createContentBlock,
  updateContentBlock,
  uploadContentBlockImages,
  deleteContentBlock,
};

export default cmsContentBlocksService;

